module.exports = {
    redData: () => {
        return[
            {
                "Raider 125":"https://www.auteco.com.co/motos-tvs/raider-125/",
                "Sport 100 ELS":"https://www.auteco.com.co/motos-tvs/tvs-sport-100-els-sp/",
                "Sport 100 KLS":"https://www.auteco.com.co/motos-tvs/tvs-sport-100-kls-sp/",
                "Max 125":"https://www.auteco.com.co/motos-tvs/max-125/",
                "Stryker":"https://www.auteco.com.co/motos-tvs/stryker-125/",
                "Apache 160 2V": 'https://www.auteco.com.co/motos-tvs/apache-rtr-160-2v/',
                "Apache 160 4V": 'https://www.auteco.com.co/motos-tvs/apache-rtr-160-4v/',
                "Apache 180 2V": 'https://www.auteco.com.co/motos-tvs/apache-rtr-180-2v/',
                "Apache 200 2V": 'https://www.auteco.com.co/motos-tvs/apache-rtr-200-4v-2023/',
                "Apache 200 fi": 'https://www.auteco.com.co/motos-tvs/apache-200-4v-fi-abs/',
                "Apache RR 310": 'https://www.auteco.com.co/motos-tvs/apache-rr-310/',
                "Ntorq 125": "https://www.auteco.com.co/motos-tvs/ntorq-125/",
                "Ntorq 125 Racing":"https://www.auteco.com.co/motos-tvs/ntorq-125-racing-2023/",
                "Ntorq 125 fi": "https://www.auteco.com.co/motos-tvs/ntorq-125-race-edition-fi/",
                "Motocarro King Basico": "https://www.auteco.com.co/motos-tvs/tvs-king-gs/",
                "Motocarro King Carpa Especial": "https://www.auteco.com.co/motos-tvs/tvs-king-gs-especial/",
                "Motocarro King Carpa Full": "https://www.auteco.com.co/motos-tvs/tvs-king-gs-full/",
                "Neo NX 110": "https://www.auteco.com.co/motos-tvs/neo-nx-110/",
            }
        ]
    }
}